import * as Sentry from '@sentry/react';
import { ENV } from '@utils';
import moment from 'moment';
import 'moment/locale/fr';
import React, { useEffect } from 'react';

moment.locale('fr');

export const InitialiseThirdParties: React.FunctionComponent = () => {
    useEffect(() => {
        if (ENV.APP_ENV !== 'local' && ENV.APP_ENV !== 'dev') {
            Sentry.init({
                dsn: ENV.SENTRY_DSN,
                environment: ENV.APP_ENV,
                sendDefaultPii: true,
                integrations: []
            });
        }
    }, []);

    return null;
};
